export default __webpack_public_path__ + "static/media/AIS_Gold_Stacked.c957762b.png";